import { DependenciesInjection } from "app/di/DependencyInjection";
import { TravelSimRegistrationImpl } from "features/travelSimRegistration/data/TravelSimRegistrationImpl";
import { ITravelSimRegistrationRepository } from "features/travelSimRegistration/domain/repositories/ITravelSimRegistrationRepository";
import { TravelSimRegistrationUseCase } from "features/travelSimRegistration/domain/useCases/TravelSimRegistrationUseCase";
import { OutboundRegistrationViewModel } from "features/travelSimRegistration/presentation/viewModel/OutboundRegistrationViewModel";
import { TravelSimRegistrationViewModel } from "features/travelSimRegistration/presentation/viewModel/TravelSimRegistrationViewModel";
import { TravelSimRegistrationToken } from "features/travelSimRegistration/di/TravelSimRegistrationToken";

export class TravelSimRegistrationInjection {
  static initInjections(): void {
    DependenciesInjection.register<ITravelSimRegistrationRepository>(
      TravelSimRegistrationToken.ITravelSimRegistrationRepository,
      TravelSimRegistrationImpl,
      "otherRepo",
    );
    DependenciesInjection.register<TravelSimRegistrationUseCase>(
      TravelSimRegistrationToken.TravelSimRegistrationUseCase,
      TravelSimRegistrationUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<TravelSimRegistrationViewModel>(
      TravelSimRegistrationToken.TravelSimRegistrationViewModel,
      TravelSimRegistrationViewModel,
      "viewModel",
    );
    DependenciesInjection.register<OutboundRegistrationViewModel>(
      TravelSimRegistrationToken.OutboundRegistrationViewModel,
      OutboundRegistrationViewModel,
      "viewModel",
    );
  }

  static getTravelSimRegistrationRepo(): ITravelSimRegistrationRepository {
    return DependenciesInjection.getRepo<ITravelSimRegistrationRepository>(
      TravelSimRegistrationToken.ITravelSimRegistrationRepository,
    );
  }

  static getTravelSimRegistrationUseCase(): TravelSimRegistrationUseCase {
    return DependenciesInjection.getRepo<TravelSimRegistrationUseCase>(
      TravelSimRegistrationToken.TravelSimRegistrationUseCase,
    );
  }
}
